import Vue from 'vue'
import VueLazyload from 'vue-lazyload'
import {lazyloadImageOptions} from '@/config'

Vue.use(VueLazyload, lazyloadImageOptions)
